import { DATE_FORMAT, EMPTY_VALUE } from '../constants';
import moment from 'moment';
import 'moment/locale/ja';

const formatDate = (
  date?: Date | string | number,
  format = DATE_FORMAT,
  locale = 'ja'
) => {
  if (!date || moment(date).format() === 'Invalid date') return EMPTY_VALUE;

  moment.locale(locale);
  return moment(date).format(format);
};
export default formatDate;
